import { useLocation, useNavigate } from 'react-router-dom';
import { firebaseAuth, firebaseGetAuth } from '../../firebase/config';

import { LogoLigth } from '../Images';
import { HomeIcon,
  UserGroupIcon,
  ExclamationTriangleIcon,
  ArrowRightEndOnRectangleIcon,
  PaperAirplaneIcon
} from '@heroicons/react/24/solid';

const Aside = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
      try {
        await firebaseAuth.signOut(firebaseGetAuth);
        
        navigate('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error);
      }
    };

    return (
      <aside className="sticky bg-primary h-screen w-64 hidden sm:block shadow-xl left-0 top-0">
        <div className="p-6 items-center flex justify-center border-bottom ml-3 mr-3">
          <a
            href="/"
            className="text-white text-3xl font-semibold uppercase hover:text-gray-300 text-center"
          >
            <img src={LogoLigth} alt="" />
          </a>
        </div>
        <nav className="text-white text-base font-semibold pt-3 mt-10">
          <a
            href="/"
            className={`flex items-center ${location.pathname === '/' ? 'active-nav-link' : ''} text-white opacity-75 hover:opacity-100 py-4 pl-6 nav-item`}
          >
            <span className='text-xs w-5 mr-2'><HomeIcon className="text-while"/></span>
            Home
          </a>
          <a
            href="/users"
            className={`flex items-center ${location.pathname === '/users' ? 'active-nav-link' : ''} text-white py-4 pl-6 nav-item`}
          >
            <span className='text-xs w-5 mr-2'>
              <UserGroupIcon className="text-while"/>
            </span>
            Users
          </a>
          <a
            href="/alerts"
            className={`flex items-center ${location.pathname === '/alerts' ? 'active-nav-link' : ''} text-white py-4 pl-6 nav-item`}
          >
            <span className='text-xs w-5 mr-2'>
              <PaperAirplaneIcon className="text-while"/>
            </span>
            Send Alerts
          </a>
          <a
            href="/reports"
            className={`flex items-center ${location.pathname === '/reports' ? 'active-nav-link' : ''} text-white opacity-75 hover:opacity-100 py-4 pl-6 nav-item`}
          >
            <span className='text-xs w-5 mr-2'>
              <ExclamationTriangleIcon className="text-while"/>
            </span>
            Reports
          </a>
        </nav>
        <button
          type='button'
          className="absolute w-full upgrade-btn bottom-0 text-white flex items-center justify-center py-6 border-top"
          onClick={handleLogout}
        >
          <span className='text-xs w-5 mr-2'>
            <ArrowRightEndOnRectangleIcon className="text-while"/>
          </span>
          Logout
        </button>
      </aside>
    );
};

export default Aside;